import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssessmentRequestAnswerLink } from '../../models/assessment.model';
import { catchError, Observable, of, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  constructor(private http: HttpClient) {}

  public getAnswerLink(requestId: string): Observable<AssessmentRequestAnswerLink | null> {
    return this.http
      .get<AssessmentRequestAnswerLink>(
        `${environment.applicantApiEndpoint}/skill-cert-assessments/answer/${requestId}/link`,
      )
      .pipe(
        catchError((e) => {
          if (e instanceof HttpErrorResponse && e.status === 404) {
            return of(null);
          }
          return throwError(() => e);
        }),
      );
  }
}
